import { App } 		from 'vue'
import { Options } 	from './types'

import { useNotificationsStore } from './_store/notification.store'

export default {
	install: (app: App, options: Options = {}) => {
		if (options && options.disabled === true) return

		const notificationsStore = useNotificationsStore()
		app.config.globalProperties.$notificationsStore = notificationsStore
	}
}